import { getPlatform, isNative } from '../utils/native';

type PlatformMeta = {
  app_name: string;
  app_region: 'uk' | 'us';
  app_env: 'dev' | 'staging' | 'production';
  app_type: 'frontend';
  app_platform: string;
};

const rawEnv = {
  app_name: process.env.NEXT_PUBLIC_PLATFORM_APP_NAME || 'beehive',
  app_region: process.env.NEXT_PUBLIC_PLATFORM_APP_REGION || 'uk',
  app_env: process.env.NEXT_PUBLIC_PLATFORM_APP_ENV || 'dev',
  app_type: process.env.NEXT_PUBLIC_PLATFORM_APP_TYPE,
};

const parseAppEnv = (): PlatformMeta['app_env'] => {
  return rawEnv.app_env === 'production' || rawEnv.app_env === 'staging'
    ? rawEnv.app_env
    : 'dev';
};

const parseAppRegion = (): PlatformMeta['app_region'] => {
  const region = rawEnv.app_region;
  if (region === 'uk' || region === 'us') {
    return region;
  }
  throw new Error(
    `Invalid or missing environment variable: NEXT_PUBLIC_PLATFORM_APP_REGION must be either 'uk' or 'us', but got '${region}'`,
  );
};

const parseAppName = (): string => {
  if (!rawEnv.app_name) {
    throw new Error(
      'Missing required environment variable: NEXT_PUBLIC_PLATFORM_APP_NAME',
    );
  }
  return rawEnv.app_name;
};

const parseAppType = (): PlatformMeta['app_type'] => {
  return 'frontend'; // hardcoded for now
};

export const getPlatformMeta = (): PlatformMeta => ({
  app_name: parseAppName(),
  app_region: parseAppRegion(),
  app_env: parseAppEnv(),
  app_type: parseAppType(),
  // IMPORTANT: guard + native check
  app_platform:
    typeof window !== 'undefined' && isNative() ? getPlatform() : 'web',
});

export const publishPlatformMeta = () => {
  const meta = getPlatformMeta();
  window.PLATFORM_METADATA = meta;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    platform_meta: meta,
  });
  return meta;
};
